import axios from "axios";
import React, { Component } from "react";
import CurrencyFormat from "react-currency-format";
import { Col, Container, Row } from "reactstrap";
import constants from "../../Constants";

const baseURL = constants.baseURL;

class Section extends Component {
  constructor(props) {
    super(props);
    this.state = {
      typesOfVehicles: [],
    };
  }
  componentDidMount() {
    axios.get(baseURL + "/vehicle-types").then((repos) => {
      const typesOfVehicles = repos.data?.vehicles;
      this.setState({ typesOfVehicles });
    });
  }
  showPricing(vehicle) {
    return (
      <div>
        <div
          className="price-listing"
          style={{ fontSize: 14, color: "#2d2d2d", marginBottom: 6 }}
        >
          Price per KM:{" "}
          <span>
            <CurrencyFormat
              value={vehicle.pricePerMeterCents * 10}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"R"}
              decimalScale={2}
            />
          </span>
        </div>
        <div
          className="price-listing"
          style={{ fontSize: 14, color: "#2d2d2d", marginBottom: 6 }}
        >
          Base Fee:{" "}
          <span>
            {" "}
            <CurrencyFormat
              value={vehicle.handlingFeeCents / 100}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"R"}
              decimalScale={2}
            />
          </span>
        </div>
        {/* <div className="price-listing">
          Loading time Average:{" "}
          <span>{vehicle.loadingTimeSeconds / 60} minutes</span>
        </div> */}
        <div
          className="price-listing"
          style={{ fontSize: 14, color: "#2d2d2d", marginBottom: 0 }}
        >
          Size:± <span>{vehicle.tonnes} ton</span>
        </div>
      </div>
    );
  }
  render() {
    return (
      <React.Fragment>
        <section id="home">
          <Container>
            <Row className="justify-content-center">
              <Col>
                <div
                  className="hero-wrapper mb-4"
                >
                  <div
                    className="hero-overlay"
                  >
                    <h1
                      style={{
                        fontWeight: 700,
                        fontSize: "clamp(22px, 3.5vw, 36px)",
                        marginBottom: 12,
                      }}
                    >
                      Transparent pricing for fast, reliable goods transportation
                    </h1>
                    <p
                      style={{
                        fontSize: "clamp(14px, 2.2vw, 18px)",
                        opacity: 0.95,
                        marginBottom: 20,
                      }}
                    >
                      Driver and fuel included. Get an instant online quote in minutes.
                    </p>
                    <div style={{ display: "inline-flex", gap: 12, flexWrap: "wrap" }}>
                      <a className="prices-cta btn btn-success btn-lg" href="/quote">
                        Get instant quote
                      </a>
                      <a className="prices-cta btn btn-outline-light btn-lg" href="/quote">
                        Enter pickup & drop-off
                      </a>
                    </div>
                  </div>
                </div>

                <div className="mb-4" style={{ textAlign: "center" }}>
                  <Row>
                    <Col md={3} sm={6} xs={12} className="mb-3">
                      <div style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                        <i className="mdi mdi-truck" style={{ fontSize: 22, color: "#34D1BF" }}></i>
                        <span>Same-day delivery options</span>
                      </div>
                    </Col>
                    <Col md={3} sm={6} xs={12} className="mb-3">
                      <div style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                        <i className="mdi mdi-shield-check" style={{ fontSize: 22, color: "#34D1BF" }}></i>
                        <span>Verified drivers & partners</span>
                      </div>
                    </Col>
                    <Col md={3} sm={6} xs={12} className="mb-3">
                      <div style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                        <i className="mdi mdi-cash" style={{ fontSize: 22, color: "#34D1BF" }}></i>
                        <span>Upfront, no-surprise pricing</span>
                      </div>
                    </Col>
                    <Col md={3} sm={6} xs={12} className="mb-3">
                      <div style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                        <i className="mdi mdi-clock-outline" style={{ fontSize: 22, color: "#34D1BF" }}></i>
                        <span>Instant online quotes 24/7</span>
                      </div>
                    </Col>
                  </Row>
                </div>

                  <h2 style={{ marginTop: 8, marginBottom: 8 }}>Prices by vehicle type</h2>
                  <h3 style={{ marginTop: 0, marginBottom: 16 }}>
                    Vehicle and driver hire prices + fuel
                  </h3>
                  <Row style={{ rowGap: 16 }}>
                    {this.state.typesOfVehicles
                      .filter((v) => v.display === true)
                      ?.map((vehicle) => {
                        const image = `https://media.qiktruck.co.za/${vehicle.type}.png`;
                        const isSelected = this.state.truckType === vehicle.type;
                        return (
                          <Col
                            key={vehicle.type}
                            lg={4}
                            md={6}
                            sm={6}
                            xs={12}
                            xl={4}
                            className={"prices-truck "}
                            onClick={() =>
                              this.setState({
                                truckType: vehicle.type,
                              })
                            }
                          >
                            <a
                              href={
                                "/?trucktype=" + vehicle.type + "#addresses"
                              }
                              style={{ textDecoration: "none", color: "inherit", display: "block" }}
                            >
                              <div className={"price-card " + (isSelected ? "selected" : "")}
                                style={{ cursor: "pointer" }}>
                                <img
                                  src={image}
                                  alt={`${vehicle?.tip?.shortform || vehicle.type} vehicle`}
                                  className={
                                    "menu-truck " +
                                    (this.state.truckType === vehicle.type
                                      ? "menu-truck-selected"
                                      : "")
                                  }
                                  height="64"
                                  style={{
                                    width: "auto",
                                    objectFit: "contain",
                                    display: "block",
                                    margin: "0 auto 8px",
                                  }}
                                  loading="lazy"
                                />
                                <i
                                  className={
                                    "mdi mdi-check-circle ml-2 " +
                                    (this.state.truckType === vehicle.type
                                      ? "checked-truck"
                                      : "hide")
                                  }
                                ></i>
                                <p
                                  className="menu-truck-tip"
                                  style={{
                                    marginTop: 8,
                                    marginBottom: 8,
                                    fontWeight: 600,
                                    color: "#1b1b1b",
                                  }}
                                >
                                  {vehicle?.tip?.shortform || vehicle.type}
                                </p>
                                {this.showPricing(vehicle)}
                              </div>
                            </a>
                          </Col>
                        );
                      })}
                  </Row>
                  <br />
                  <p>
                    We ensure goods can fit in a truck before starting any job
                    through inspection.
                  </p>
                  <hr />

                  <h3 id="howitworks">How it works</h3>
                  <ul style={{ paddingLeft: 18, marginBottom: 0 }}>
                    <li>
                      <p>
                        <a
                          href="/quote"
                          style={{ borderBottom: "solid 1px blue" }}
                        >
                          Get an instant free quotation.
                        </a>
                      </p>
                    </li>
                    <li style={{ marginTop: 4 }}>
                      <p style={{ marginBottom: 6 }}>Accept quotation, pay now or pay later.</p>
                    </li>
                    <li style={{ marginTop: 4 }}>
                      <p style={{ marginBottom: 6 }}>
                        Qiktruck notifies a Driver about the order and price.
                      </p>
                    </li>
                    <li style={{ marginTop: 4 }}>
                      <p style={{ marginBottom: 6 }}>
                        The driver calls the customer to verify details of the
                        order.
                      </p>
                    </li>
                    <li style={{ marginTop: 4 }}>
                      <p style={{ marginBottom: 6 }}>
                        A driver will come to collect and deliver your goods.
                      </p>
                    </li>
                    <li style={{ marginTop: 4 }}>
                      <p style={{ marginBottom: 6 }}>Pay QikTruck as the job starts or at the end.</p>
                    </li>
                    <li style={{ marginTop: 4 }}>
                      <p style={{ marginBottom: 6 }}>QikTruck pays the Driver/Partner truck.</p>
                    </li>
                    <li style={{ marginTop: 4 }}>
                      <p style={{ marginBottom: 6 }}>Business clients/partners can pay via credit.</p>
                    </li>
                    <li style={{ marginTop: 4 }}>
                      <p style={{ marginBottom: 0 }}>Trip cancellation fee @ 35%</p>
                    </li>
                  </ul>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Section;
